module.exports = __webpack_public_path__ + "static/media/font.84c46855.woff";